
<template>
    
        <div class="law-card-wrapper law-ads-container"><div v-html="htmls"></div><script id="ad" type="text/html">
        <style type="text/css">
            <%:=wapqbmarketing.ad_place_css%>
        </style>
        <div class="<#=mixadclass#>-ecom-ads" id="<#=mixadclass#>-wapqbmarketing">
            <%if (isArrays) {%>
                <% for(var i = 0; i < adPlaceData.length; i++) {%>
                    <%:=adPlaceData[i]%>
                <%}%>
            <%} else {%>
                <%:=wapqbmarketing.ad_place_data%>
            <%}%>
        </div>
        <script>
            <%:=wapqbmarketing.ad_place_js%>
        </script></div>
    
</template>

<script>
/**
 * h5广告组件
 */
/* globals getApp, Page, swan */

export default {
  name: 'ad-h5',
  props: {
    adsData: {
      type: Object,
      default() {
        return {};
      }
    },
    // 需展示的广告的起始索引
    startIndex: {
      type: Number,
      default: 0
    },
    // 需展示的广告的结束索引（不包含）
    endIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      htmls: ''
    };
  },
  mounted() {
    this.$nextTick(() => {
      const data = this.adsData || {};
      data.isArrays = false;
      if (data.wapqbmarketing && data.wapqbmarketing.ad_place_data && Array.isArray(data.wapqbmarketing.ad_place_data)) {
        data.isArrays = true;
        let adPlaceData = data.wapqbmarketing.ad_place_data;
        let startIndex = this.startIndex || 0;
        let endIndex = this.endIndex || adPlaceData.length;
        let tmpAdPlaceData = adPlaceData.slice(startIndex, endIndex);
        data.adPlaceData = tmpAdPlaceData;
      }
      const bt = window.baidu.template;
      const html = bt && bt('ad', data);
      this.htmls = html;
      let jsTimeout = setTimeout(() => {
        let ecomJsfunc = new Function(data.wapqbmarketing.ad_place_js);
        // <!--bca-enable-->
        ecomJsfunc();
        clearTimeout(jsTimeout);
        jsTimeout = null;
      }, 500);
    });
  }
};
</script>

<style scoped>

</style>
